/**
 * Creates a diamond-shaped marker for tooltip display.
 * Used for type well series to match the diamond symbol on the chart.
 */
const getSeriesTooltipDiamond = (color: string): string => {
  const newColor = color || "black";

  // Diamond shape using CSS transform rotate on a square
  return `<span style="display:inline-block;margin-right:5px;width:10px;height:10px;background-color:${newColor};transform:rotate(45deg)"></span>`;
};

export default getSeriesTooltipDiamond;
